import { CaretUpDownIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { type HTMLAttributes } from "react";
import { useTranslations } from "use-intl";

type Props = HTMLAttributes<HTMLButtonElement>;

function SwapValuesButton({ className, onClick }: Props) {
  const t = useTranslations();

  return (
    <button
      type="button"
      className={clsx(
        className,
        "cursor-pointer transition-transform active:scale-90",
      )}
      onClick={onClick}
      aria-label={t("swapValues")}
    >
      <CaretUpDownIcon
        height={40}
        width={26}
        color="white"
        className="rounded-2xl bg-surface-neutral-stronger"
        aria-hidden
      />
    </button>
  );
}

export default SwapValuesButton;
